module.exports = __webpack_public_path__ + "h5/img/repairs.36cbfeaa.png";